import { flowRight } from 'lodash';

export default (...args: Array<(...args: any[]) => any>) => flowRight(args);
